import React from 'react';
import { withTheme } from 'styled-components';
import { Box } from '@rsos/components/capstone/base';
import { useFlag } from '@rsos/flags';
import { DARK_THEME } from '@rsos/theme/constants';
import { RapidSOSLogoCompact, FullLogo } from '../../common/logo/RapidSOSLogo';
import { PremiumText, TextContainer } from './PremiumLogo.styles';

const PremiumLogo = ({ theme, compact, showUniteLogo = false }) => {
  const { name: themeName = '' } = theme.colors;
  const isDarkMode = themeName === DARK_THEME;
  const isRebrandedLogo = useFlag('rebranded_logo');

  if (compact) {
    return <RapidSOSLogoCompact />;
  }

  return (
    <Box horizontal flow={7} align="center">
      <FullLogo
        showUniteLogo={showUniteLogo}
        color={isDarkMode ? 'background' : 'primaryText'}
      />
      {!isRebrandedLogo && showUniteLogo && (
        <TextContainer>
          <PremiumText color={isDarkMode ? 'background' : 'primaryText'} />
        </TextContainer>
      )}
    </Box>
  );
};
export default withTheme(PremiumLogo);
